'use client'

import '../_ui/index.scss'
import Image from 'next/image'
import Link from 'next/link'

import VideoFh from '../_videos/fashionhouse_1.mp4'
import PreviewImage from '../_images/preview.png'
import Image2 from '../_images/2.png'
import Image3 from '../_images/3.png'
import Image4 from '../_images/4.png'
import Image5 from '../_images/5.png'
import Image6 from '../_images/6.png'
import Image7 from '../_images/7.png'
import Image8 from '../_images/8.png'
import Image9 from '../_images/9.png'
import Image10 from '../_images/10.png'
import Image11 from '../_images/11.png'
import ImageReact from '../_images/react.svg?url'
import Image1C from '../_images/1c.svg?url'
import ImageAnalytics from '../_images/analytics.svg?url'

const CaseFh = () => {
  return (
    <article>
      <div className="StyledCase__Case-sc-f7a5d759-0 dIsYUX">
        <div className="StyledCase-sc-f7a5d759-1 gPAlpi">
          <div className="StyledContainer__Container-sc-8319b358-0 iIXpOG">
            <div className="StyledCase-sc-f7a5d759-2 bQZtoP">
              <div className="StyledCase-sc-f7a5d759-4 dRdDbE">August 6, 2020</div>
              <h1 className="StyledCase-sc-f7a5d759-3 iCcNjE">Fashion House</h1>
              <div className="StyledCase-sc-f7a5d759-5 iuFrap">
                The boundaries between online and offline for a large retailer have been blurred.
                The website, the application and a dozen integrations have been made. Fully
                digitalized business with 30 stores and 10 million visitors per year
              </div>
              <Link
                href="https://fh.by"
                target="_blank"
                className="StyledCase-sc-f7a5d759-6 hZmmTA"
              >
                <span>fh.by</span>
              </Link>
              <div className="StyledCase-sc-f7a5d759-7 ctSmxx">
                <Link
                  target="_blank"
                  href="https://apps.apple.com/us/app/id1518240278"
                  className="StyledCase-sc-f7a5d759-8 ccufqb"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="26">
                    <path d="M22 19.074c-.863 2.472-3.453 6.842-6.118 6.892-1.768.033-2.338-1.032-4.358-1.032-2.02 0-2.653.999-4.325 1.065C4.366 26.106 0 19.685 0 14.085c0-5.142 3.637-7.689 6.818-7.738 1.705-.029 3.315 1.13 4.354 1.13 1.043 0 3-1.398 5.053-1.192.86.037 3.277.343 4.828 2.575-4.11 2.65-3.47 8.18.947 10.214zM16.255 0c-3.11.124-5.645 3.334-5.293 5.992 2.875.219 5.632-2.95 5.293-5.992z"></path>
                  </svg>
                  <span>
                    Download from <br /> App Store
                  </span>
                </Link>
                <Link
                  target="_blank"
                  href="https://play.google.com/store/apps/details?id=com.websecret.fh"
                  className="StyledCase-sc-f7a5d759-8 ccufqb"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" fill="none">
                    <path
                      fill="#FFD900"
                      d="M15.188 14.39c2.606-1.43 4.598-2.52 4.766-2.606.546-.288 1.108-1.056 0-1.652-.356-.19-2.28-1.242-4.766-2.607l-3.423 3.44 3.423 3.425Z"
                    ></path>
                    <path
                      fill="#F43249"
                      d="M11.765 10.968.833 21.983c.254.034.545-.035.885-.223.717-.391 8.309-4.547 13.466-7.373l-3.419-3.419Z"
                    ></path>
                    <path
                      fill="#00EE76"
                      d="m11.765 10.968 3.423-3.44S2.486.599 1.722.19A1.323 1.323 0 0 0 .82.02l10.945 10.95Z"
                    ></path>
                    <path
                      fill="#00D3FF"
                      d="M11.765 10.969.816.023C.374.123 0 .513 0 1.316V20.69c0 .73.288 1.259.833 1.31L11.765 10.97Z"
                    ></path>
                  </svg>
                  <span>
                    Download from <br /> Google Play
                  </span>
                </Link>
              </div>
            </div>
            <div className="StyledCase-sc-f7a5d759-9 hndEX">
              <Image src={PreviewImage} width={890} height={700} alt="Intro Fashion House" />
            </div>
          </div>
        </div>
      </div>
      <section className="StyledSection__Section-sc-1564f4d4-0 fxfViC">
        <div className="StyledContainer__Container-sc-8319b358-0 jFOrji">
          <div className="StyledContentBlock__Block-sc-40774080-0 JmBhP">
            <div className="StyledContentBlock-sc-40774080-1 cxVVnq">
              <h2>More than e-commerce: Fashion House website and App</h2>
            </div>
            <div className="StyledContentBlock-sc-40774080-1 cxVVnq">
              <p>
                Fashion House is one of the main and oldest retailers in Belarus, which represents
                top fashion brands: from Mango to Emporio Armani.
              </p>
              <p>
                A year ago only the company was not even represented in the Internet, but today it
                has one of the most advanced e-commerce solutions and complex integration with
                dozens of services. It is quite possible that Fashion House will become the
                Belarusian pioneer in new retail, which will combine offline and online into one
                whole unit.
              </p>
              <p>
                <strong>Objective:</strong> to create an e-commerce solution from scratch with a lot
                of potential for the future.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="StyledSection__Section-sc-1564f4d4-0 UWwwN">
        <div className="StyledContainer__Container-sc-8319b358-0 jFOrji">
          <div className="StyledContentBlock-sc-40774080-6 bUlSdW">
            <video poster="/images/fh/1.jpg" preload="metadata" autoPlay muted loop>
              <source src={VideoFh} type="video/mp4" />
            </video>
          </div>
        </div>
      </section>
      <section className="StyledSection__Section-sc-1564f4d4-0 fxfViC">
        <div className="StyledContainer__Container-sc-8319b358-0 jFOrji">
          <div className="StyledContentBlock__Block-sc-40774080-0 JmBhP">
            <div className="StyledContentBlock-sc-40774080-1 cxVVnq">
              <h2>Project outside: only shopping and nothing superfluous</h2>
            </div>
            <div className="StyledContentBlock-sc-40774080-1 cxVVnq">
              <p>
                <strong>Catalog</strong>
              </p>
              <p>
                Clean pages without information noise and an advanced catalog with dependent
                filters. There are no banners, news, promotional blocks, unnecessary small details.
                Everything is done in such a way as to immediately plunge into the world of
                shopping.
              </p>
              <p>
                The filter system is different from most of the stores. They are very compact,
                conditions are applied instantly, without reloading the page. No “Apply” buttons at
                all. Due to this search speed increases significantly, it becomes light and
                invisible, like air.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="StyledSection__Section-sc-1564f4d4-0 bLzQMy">
        <div className="StyledContainer__Container-sc-8319b358-0 jFOrji">
          <Image src={Image2} width={1200} height={911} alt="Fashion House" />
        </div>
      </section>
      <section className="StyledSection__Section-sc-1564f4d4-0 fxfViC">
        <div className="StyledContainer__Container-sc-8319b358-0 hCiKSt">
          <div className="StyledText__Text-sc-398a1132-0 bVmrHc">
            <p>
              <strong>Product page</strong>
            </p>
            <p>
              Everything is minimalistic and functional here. Secondary text blocks open on click
              and do not overload the overall picture. There is an opportunity to add not only
              photos, but also videos, which there will me more and more in e-commerce.
            </p>
            <p>
              When changing colors, only available sizes will be shown, and vice versa. There is a
              size chart on every page, which will not let you mess up, no matter what markings the
              manufacturer uses.
            </p>
          </div>
        </div>
      </section>
      <section className="StyledSection__Section-sc-1564f4d4-0 kjqfsG">
        <div className="StyledContainer__Container-sc-8319b358-0 gESYRP">
          <div className="fh__StyledSubsImage-sc-1eae83e2-0 iZOBKC">
            <div className="sc-1eae83e2-1 inOCOn">
              <Image src={Image3} width={945} height={2280} alt="Fashion House" />
            </div>
            <div className="sc-1eae83e2-2 eXoNFT">
              A tool for forming looks has been brought up, the products that are ideally combined
              with the chosen clothing or footwear. This is a complete win-win, because the user
              does not need to be a fashion expert, and the store receives a high-quality
              cross-sale.
            </div>
            <div className="sc-1eae83e2-2 bMhPMY">
              For sure, the selection of similar products and browsing history also takes place
              here. Though they were moved to the very bottom of the page, as the information is
              interesting, but not the most important.
            </div>
          </div>
        </div>
      </section>
      <section className="StyledSection__Section-sc-1564f4d4-0 fxfViC">
        <div className="StyledContainer__Container-sc-8319b358-0 hCiKSt">
          <div className="StyledText__Text-sc-398a1132-0 bVmrHc">
            <h2>Inside of the project: React, API and many integrations</h2>
            <p>
              From the user perspective, Fashion House looks like thousands of pages, but
              technically it is a Single Page Web Application (SPA) built on the React framework.
              Remember, we mentioned instant filters and website loading speed? This is exactly the
              result of this development method: pages are refreshed without a total reload.
            </p>
            <p>
              The website and the mobile app use one API, which allows any changes in the back-end
              to be applied to both the website and the app at the same time.
            </p>
            <div className={'integrations'}>
              <Image src={ImageReact} width={203} height={181} alt="React" />
            </div>
            <p>
              Another feature of the project is the minimum of operations through the control panel
              and a large number of integrations. Due to this the website is very independent:
              keeping the catalog up to date, processing orders, collecting analytics - everything
              happens automatically and continuously.
            </p>
            <p>
              <strong>1C and catalog creation</strong>
            </p>
            <p>
              We have a rich experience of working with 1C, though the Fashion House case is a real
              level up. There are many variables behind each item of clothing, and there are tens of
              thousands of items in catalogs. The data should be updated almost in real time. But a
              user sees only relevant data about the product: sizes, colors, stores, where a
              specific product with the required parameters is in stock right now.
            </p>
            <div className={'integrations'}>
              <Image src={Image1C} width={278} height={136} alt="1C" />
            </div>
            <p>
              If you don’t hurry to pay, and the last thing leaves the warehouse, you will be
              promptly notified of this. It is simply impossible to buy missing goods here. We hope
              that such benefits of civilization will someday reach such services like booking.com.
            </p>
            <p>
              <strong>CRM, marketing and analytics</strong>
            </p>
            <p>
              We make functional business tools that are doing well with data collection and
              processing. Fashion House already has an advanced analytics system: the customer
              receives detailed data on which categories and brands are the most popular, who are
              their users, how much the attraction costs, what products are viewed more often, what
              goes into the basket.
            </p>
            <div className={'integrations'}>
              <Image src={ImageAnalytics} width={176} height={206} alt="analytics" />
            </div>
            <p>
              An email marketing tool is also connected for high-quality dealing with databases via
              email and sms.
            </p>
            <p>
              Authorization on the site occurs by phone number. We and most of our clients are in
              favor of this method of signing in on the site, for a number of reasons at once: no
              logins and passwords, simple and quick access to your account, increased security,
              plus only valid users.
            </p>
            <p>Next in line for integration is a CRM system with powerful functionality:</p>
            <ul className="list">
              <li>the simplest possible dealing with orders;</li>
              <li>
                combining all sales channels and attracting customers from the website and App to
                the Instagram account;
              </li>
              <li>segmentation and work with funnels;</li>
              <li>card of each client;</li>
              <li>recommendation management, etc.</li>
            </ul>
            <p>
              <strong>Discount system</strong>
            </p>
            <p>
              Here we have disengaged users from plastic discount cards, and the customer from the
              need to produce them and spend thousands of dollars on it additionally. Now the
              discount system is a full-fledged online tool connected with 1C, which takes into
              account dozens of options for different discounts: general, for certain categories,
              cumulative, personal, etc.
            </p>
            <p>
              The customer card is now in the App and not only online, but also offline orders are
              recorded on it. All purchase history is available in the user&#x27;s profile.
            </p>
            <p>
              The system of applying discounts turned out to be difficult to implement, but it looks
              simple for a user. A regular discount on a product, a discount on a card or
              promotional codes – nothing will be mixed and will be clearly seen while ordering.
            </p>
          </div>
        </div>
      </section>
      <section className="StyledSection__Section-sc-1564f4d4-0 eLKGjH">
        <div className="StyledContainer__Container-sc-8319b358-0 jFOrji">
          <Image src={Image4} width={1200} height={735} alt="Discount system" />
        </div>
      </section>
      <section className="StyledSection__Section-sc-1564f4d4-0 fxfViC">
        <div className="StyledContainer__Container-sc-8319b358-0 jFOrji">
          <div className="StyledContentBlock__Block-sc-40774080-0 JmBhP">
            <div className="StyledContentBlock-sc-40774080-1 cxVVnq">
              <h2>Fashion House App</h2>
            </div>
            <div className="StyledContentBlock-sc-40774080-1 cxVVnq">
              <p>
                Due to the use of React Native, the App works equally well on iOS and Android, using
                the native technologies of a specific operating system.
              </p>
              <p>
                Although this platform is occasionally criticized by developers, the remaining 99%
                of the time it successfully solves the problem of quickly creating applications and
                saving the customer&#x27;s money. Facebook, Instagram, Bloomberg, Airbnb work great
                on it.
              </p>
              <p>
                React Native will make the Fashion House app very easy to maintain and customize.
                And due to the use of the API common with the website, any updates to the
                website&#x27;s functionality will be pulled here.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="StyledSection__Section-sc-1564f4d4-0 gftERz">
        <div className="StyledContainer__Container-sc-8319b358-0 jFOrji">
          <div className="StyledContentBlock__Block-sc-40774080-0 JmBhP">
            <div className="StyledContentBlock-sc-40774080-1 cxVVnq">
              <p>
                <strong>Convenient navigation</strong>
              </p>
            </div>
            <div className="StyledContentBlock-sc-40774080-1 cxVVnq">
              <p>
                Promoblocks, sales, promotions, convenient navigation personalized for each gender.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="StyledSection__Section-sc-1564f4d4-0 iZyHbg">
        <div className="StyledContainer__Container-sc-8319b358-0 gESYRP">
          <Image src={Image5} width={1536} height={586} alt="Convenient navigation" />
        </div>
      </section>
      <section className="StyledSection__Section-sc-1564f4d4-0 eIZaAY">
        <div className="StyledContainer__Container-sc-8319b358-0 jFOrji">
          <div className="StyledContentBlock__Block-sc-40774080-0 bIyAya">
            <div className="StyledContentBlock-sc-40774080-1 cxVVnq">
              <p>
                <strong>Product search by barcode</strong>
              </p>
            </div>
            <div className="StyledContentBlock-sc-40774080-1 cxVVnq">
              <p>
                The App has all the advantages of the Fashion House web version and even a little
                more. For example, the ability to scan a barcode in a store and get to the product
                page in the catalog. This gives customers the access to the data that previously
                only store employees had: all information about sizes, colors, and availability in
                specific stores. And all this in real time, of course.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="StyledSection__Section-sc-1564f4d4-0 jZjtTX">
        <div className="StyledContainer__Container-sc-8319b358-0 gESYRP">
          <Image src={Image6} width={1536} height={586} alt="Product search by barcode" />
        </div>
      </section>
      <section className="StyledSection__Section-sc-1564f4d4-0 gftERz">
        <div className="StyledContainer__Container-sc-8319b358-0 jFOrji">
          <div className="StyledContentBlock__Block-sc-40774080-0 JmBhP">
            <div className="StyledContentBlock-sc-40774080-1 cxVVnq">
              <p>
                <strong>Convenient catalog</strong>
              </p>
            </div>
            <div className="StyledContentBlock-sc-40774080-1 cxVVnq">
              <p>Convenient dependent filters, search for typos, popular sorts.</p>
            </div>
          </div>
        </div>
      </section>
      <section className="StyledSection__Section-sc-1564f4d4-0 iZyHbg">
        <div className="StyledContainer__Container-sc-8319b358-0 gESYRP">
          <Image src={Image7} width={1536} height={586} alt="Convenient catalog" />
        </div>
      </section>
      <section className="StyledSection__Section-sc-1564f4d4-0 eIZaAY">
        <div className="StyledContainer__Container-sc-8319b358-0 jFOrji">
          <div className="StyledContentBlock__Block-sc-40774080-0 bIyAya">
            <div className="StyledContentBlock-sc-40774080-1 cxVVnq">
              <p>
                <strong>Informative product screen</strong>
              </p>
            </div>
            <div className="StyledContentBlock-sc-40774080-1 cxVVnq">
              <p>
                Product screen with photos, videos, available sizes in stores. Composite images with
                this item.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="StyledSection__Section-sc-1564f4d4-0 jZjtTX">
        <div className="StyledContainer__Container-sc-8319b358-0 gESYRP">
          <Image src={Image8} width={1536} height={586} alt="Informative product screen" />
        </div>
      </section>
      <section className="StyledSection__Section-sc-1564f4d4-0 gftERz">
        <div className="StyledContainer__Container-sc-8319b358-0 jFOrji">
          <div className="StyledContentBlock__Block-sc-40774080-0 JmBhP">
            <div className="StyledContentBlock-sc-40774080-1 cxVVnq">
              <p>
                <strong>Nearest shops on the map</strong>
              </p>
            </div>
            <div className="StyledContentBlock-sc-40774080-1 cxVVnq">
              <p>
                Search based on geolocation, building a route to the nearest stores with the
                selected clothes.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="StyledSection__Section-sc-1564f4d4-0 iZyHbg">
        <div className="StyledContainer__Container-sc-8319b358-0 gESYRP">
          <Image src={Image9} width={1536} height={586} alt="Nearest shops on the map" />
        </div>
      </section>
      <section className="StyledSection__Section-sc-1564f4d4-0 eIZaAY">
        <div className="StyledContainer__Container-sc-8319b358-0 jFOrji">
          <div className="StyledContentBlock__Block-sc-40774080-0 bIyAya">
            <div className="StyledContentBlock-sc-40774080-1 cxVVnq">
              <p>
                <strong>Convenient design</strong>
              </p>
            </div>
            <div className="StyledContentBlock-sc-40774080-1 cxVVnq">
              <p>
                Ordering a self-pickup, a delivery in a few steps, and for authorized users even
                faster. Payment using Apple Pay, Google Pay.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="StyledSection__Section-sc-1564f4d4-0 jZjtTX">
        <div className="StyledContainer__Container-sc-8319b358-0 gESYRP">
          <Image src={Image10} width={1536} height={586} alt="Convenient design" />
        </div>
      </section>
      <section className="StyledSection__Section-sc-1564f4d4-0 gftERz">
        <div className="StyledContainer__Container-sc-8319b358-0 jFOrji">
          <div className="StyledContentBlock__Block-sc-40774080-0 JmBhP">
            <div className="StyledContentBlock-sc-40774080-1 cxVVnq">
              <p>
                <strong>Personal account</strong>
              </p>
            </div>
            <div className="StyledContentBlock-sc-40774080-1 cxVVnq">
              <p>Purchase history, delivery addresses, bonus accumulation.</p>
            </div>
          </div>
        </div>
      </section>
      <section className="StyledSection__Section-sc-1564f4d4-0 iZyHbg">
        <div className="StyledContainer__Container-sc-8319b358-0 gESYRP">
          <Image src={Image11} width={1536} height={586} alt="Personal account" />
        </div>
      </section>
      <section className="StyledSection__Section-sc-1564f4d4-0 fxfViC">
        <div className="StyledContainer__Container-sc-8319b358-0 jFOrji">
          <div className="StyledContentBlock-sc-40774080-4 eRySoL">
            <div className="StyledText__Text-sc-398a1132-0 bVmrHc">
              <p>
                We mentioned the online customer card in the App. There are plans for a serious
                modification of the functionality that will help to fully integrate traditional and
                online purchases into one another and, in fact, make shopping seamless.
              </p>
              <p>
                Soon, behind the history of purchases, a history of fittings and a whole range of
                opportunities will become possible, which will allow retailers to take their
                business to a completely new level. How about ordering clothes through the App
                straight to your fitting room along with recommended items based on your
                preferences? This is not a distant future, because we are already engaged in
                developing the appropriate IT equipment of Fashion House stores.
              </p>
            </div>
          </div>
          <div className="StyledContentBlock-sc-40774080-10 dDqrvZ">
            <Link href="https://fh.by" target="_blank" className="StyledCase-sc-f7a5d759-6 kAVxpC">
              <span>fh.by</span>
            </Link>
            <div className="StyledCase-sc-f7a5d759-7 ctSmxx">
              <Link
                target="_blank"
                href="https://apps.apple.com/us/app/id1518240278"
                className="StyledCase-sc-f7a5d759-8 gNrxDE"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="26">
                  <path d="M22 19.074c-.863 2.472-3.453 6.842-6.118 6.892-1.768.033-2.338-1.032-4.358-1.032-2.02 0-2.653.999-4.325 1.065C4.366 26.106 0 19.685 0 14.085c0-5.142 3.637-7.689 6.818-7.738 1.705-.029 3.315 1.13 4.354 1.13 1.043 0 3-1.398 5.053-1.192.86.037 3.277.343 4.828 2.575-4.11 2.65-3.47 8.18.947 10.214zM16.255 0c-3.11.124-5.645 3.334-5.293 5.992 2.875.219 5.632-2.95 5.293-5.992z"></path>
                </svg>
                <span>
                  Download from <br /> App Store
                </span>
              </Link>
              <Link
                target="_blank"
                href="https://play.google.com/store/apps/details?id=com.websecret.fh"
                className="StyledCase-sc-f7a5d759-8 gNrxDE"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" fill="none">
                  <path
                    fill="#FFD900"
                    d="M15.188 14.39c2.606-1.43 4.598-2.52 4.766-2.606.546-.288 1.108-1.056 0-1.652-.356-.19-2.28-1.242-4.766-2.607l-3.423 3.44 3.423 3.425Z"
                  ></path>
                  <path
                    fill="#F43249"
                    d="M11.765 10.968.833 21.983c.254.034.545-.035.885-.223.717-.391 8.309-4.547 13.466-7.373l-3.419-3.419Z"
                  ></path>
                  <path
                    fill="#00EE76"
                    d="m11.765 10.968 3.423-3.44S2.486.599 1.722.19A1.323 1.323 0 0 0 .82.02l10.945 10.95Z"
                  ></path>
                  <path
                    fill="#00D3FF"
                    d="M11.765 10.969.816.023C.374.123 0 .513 0 1.316V20.69c0 .73.288 1.259.833 1.31L11.765 10.97Z"
                  ></path>
                </svg>
                <span>
                  Download from <br /> Google Play
                </span>
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section className="CaseGetInTouch__StyledCaseGetInTouch-sc-8ea8cd45-1 fRbkgK">
        <div className="Box__StyledBox-sc-c4aceb60-0 cQvrhJ">
          <div className="CaseGetInTouch__StyledCaseGetInTouchInner-sc-8ea8cd45-2 WOYmp">
            <div className="CaseGetInTouch__StyledCaseGetInTouchTitle-sc-8ea8cd45-3 gEpbKh">
              <h3 className="Title__StyledTitle-sc-be5cc357-2 kYIfWN">
                <span className="Title__StyledTitleText-sc-be5cc357-0 bPsPXD">
                  Have a similar project?
                </span>
              </h3>
            </div>
            <div className="CaseGetInTouch__StyledCaseGetInTouchButton-sc-8ea8cd45-4 dQaOIb">
              <Link
                target="_self"
                href="/project-evaluation"
                className="Button__StyledButton-sc-8dd8888c-0 fBllft"
              >
                <span className="Button__StyledButtonText-sc-8dd8888c-2 dKRYXh">
                  <span className="Button__StyledButtonTextInner-sc-8dd8888c-3 cpcecI">
                    Get in touch
                  </span>
                </span>
                <svg width="100%" x="0px" y="0px" viewBox="0 0 60 60">
                  <circle cx="30" cy="30" r="28.7"></circle>
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </article>
  )
}

export default CaseFh
